export default __webpack_public_path__ + "static/media/image-work-team-m@2x.cae216fb.webp";